import { render, staticRenderFns } from "./EditConnection.vue?vue&type=template&id=4671a634"
import script from "./EditConnection.vue?vue&type=script&lang=ts"
export * from "./EditConnection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports